import React, { useState } from "react";
import {motion} from "framer-motion";

function Ressources() {
    const filters = [
        "Contact",
        "Dispositifs et aides",
        "Ressources utiles",
        "Documents",
    ];

    const [page, setPage] = useState(0);

    const handleClick = (event, pageId) => {
        event.preventDefault();
        if (page !== pageId) setPage(pageId);
    };

    const tabContents = [
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab0"
            className={'tab-content-item'}>

            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/sante.svg" alt="" />
                <span>Vos experts santé</span>
            </div>
            <ul>
                <li>
                    Le médecin du travail est présent pour vous renseigner sur vos
                    questions de santé et vos démarches...
                </li>
                <li>
                    L’assistant(e) social vous informe sur vos droits, vous conseille...
                </li>
            </ul>

            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/relais.svg" alt="" />
                <span>Vos relais internes</span>
            </div>
            <ul>
                <li>
                    La Mission handicap pourra répondre à vos questions liées à l’impact
                    de votre handicap...
                </li>
                <li>
                    Votre Gestionnaire RH vous accompagne en cas d’aménagement de poste...
                </li>
            </ul>

            <div className={'tab-content-item-title'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/experts.svg" alt="" />
                <span>Vos experts externes</span>
            </div>
            <ul>
                <li>
                    La Maison Départementale des Personnes Handicapées (MDPH) pourra
                    répondre à toutes vos questions.
                </li>
            </ul>
        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab1"
            className={'tab-content-item'}>
                <img className={'picture'} src="../images/resssources_handicap/dispositifs.svg" alt="Ressources" />
                <ul>
                    <li>
                        1 journée d’absence rémunérée pour réaliser ses démarches
                        administratives
                    </li>
                    <li>
                        Majoration de 300€/an du CPF (dispositif gouvernemental)
                    </li>
                </ul>
            <div className={'tab-content-item-title text-rose'}>
                <img className={'tab-content-item-icon'} src="../images/resssources_handicap/warning.svg" alt="" />
                <span>
                  Les besoins sont propres à chaque personne et à chaque situation
                  <br />
                  Les aménagements sont individuels et mis en place sur préconisation
                  médicale
                </span>
            </div>

        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab2"
            className={'tab-content-item'}>
                <div className={'tab-content-item-title'}>
                    <img className={'tab-content-item-icon'} src="../images/resssources_handicap/portail.svg" alt="" />
                    <span>Portail Mission Handicap dédié</span>
                </div>

                <ul>
                    <li>
                        <a href={"https://mybourso.boursorama.fr/handicap"} target={'_blank'}>
                            https://mybourso.boursorama.fr/handicap
                        </a>
                    </li>
                </ul>

                <div className={'tab-content-item-title'}>
                    <img className={'tab-content-item-icon'} src="../images/resssources_handicap/arobasse.svg" alt="" />
                    <span>Adresse mail dédiée</span>
                </div>
                <ul>
                    <li>
                        <a href={"mailto:mission.handicap@boursorama.fr"}>
                            mission.handicap@boursorama.fr
                        </a>
                    </li>
                </ul>

                <div className={'tab-content-item-title'}>
                    <img className={'tab-content-item-icon'} src="../images/resssources_handicap/axa.png" alt="" />
                    <span>Ligne téléphonique AXA</span>
                </div>
                <ul>
                    <li>
                        Accès à un soutien psychologique à raison de 4 séances par an...
                    </li>
                </ul>

                <div className={'tab-content-item-title'}>
                    <img className={'tab-content-item-icon'} src="../images/resssources_handicap/hands.svg" alt="" />
                    <span>Santé au travail</span>
                </div>

                <div className={'tab-content-item-duo'}>
                        <p>
                            <div className={'tab-content-item-title arrow'}>
                                <span className={'text-rose'}>Boulogne - PrevLink Santé au travail</span>
                            </div>
                            <span className={'text-black'}><b>Adresse</b> : 88 ter avenue du général Leclerc, 92100 Boulogne</span>
                            <span className={'text-black'}><b>Téléphone</b> : 01 46 45 90 72</span>
                            <span className={'text-black'}><b>Médecin</b> : Elisabetta GAROFALO</span>
                            <span className={'text-black'}><b>Assistante sociale</b> : Virginie LIMOUZIN</span>
                            <span className={'text-black'}><b>Site web</b> : www.prevlink.com</span>
                        </p>
                        <p>
                            <div className={'tab-content-item-title arrow'}>
                                <span className={'text-rose'}>Nancy - ALSMT Association Lorraine</span>
                            </div>
                            <span className={'text-black'}><b>Adresse</b> : 8, Place de la République, 54000 Nancy</span>
                            <span className={'text-black'}><b>Téléphone</b> : 03 83 36 91 35</span>
                        </p>
                </div>
        </motion.div>,

        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ ease: 'easeInOut', duration: 0.5 }}
            key="tab3"
            className={'tab-content-item'}>
            <div className={'row'}>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue'}>Accord handicap.pdf</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue'}>Charte handicap.pdf</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue'}>DOETH.pdf</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-image"></span>
                        <span className={'text-blue'}>logo.jpg</span>
                    </a>
                </div>
            </div>

            <div className={'row'}>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-word"></span>
                        <span className={'text-blue'}>Questionnaire.word</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-video"></span>
                        <span className={'text-blue'}>Témoignage.mp4</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue'}>Convention collective.pdf</span>
                    </a>
                </div>
                <div className={'col-sm-6 col-lg-3 col-xs-3'}>
                    <a href={'#'} target='_blank'
                       className={'d-flex flex-column align-items-center gap-2'}>
                        <span className="doc-icons fa fa-file-pdf"></span>
                        <span className={'text-blue'}>Accord handicap.pdf</span>
                    </a>
                </div>
            </div>
        </motion.div>
    ];

    return (
        <section className="ressources-section layout-pt-60 layout-pb-60">
            <div className="auto-container">
                <div className="text-center">
                    <h2 className="libre-title">
                        Vos ressources handicap <span>à portée de clic</span>
                    </h2>
                </div>

                <div className="row mt-30">
                    <div className="tab-header">
                        <ul className="tab-header-menu">
                            {filters.map((filter, index) => (
                                <li
                                    key={`menu_${index}`}
                                    className={`tab-header-menu-item ${
                                        index === page ? "tab-header-menu-item-active" : ""
                                    }`}
                                    onClick={(event) => handleClick(event, index)}
                                >
                                    <span>{filter}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="tab-content">{tabContents[page]}</div>

                </div>
            </div>
        </section>
    );
}

export default Ressources;
